// extracted by mini-css-extract-plugin
export default {"contpag":"Paginado_contpag__3qQaG","botpag":"Paginado_botpag__pPGHi"};